module.exports = __webpack_public_path__ + "img/kitchen.656210c.jpeg";